type ScoreChangeListener = (eventId: string, side: 'home' | 'away') => void;

const listeners = new Set<ScoreChangeListener>();

export const subscribeToScoreChange = (listener: ScoreChangeListener) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

export const emitScoreChange = (eventId: string, side: 'home' | 'away') => {
  listeners.forEach((listener) => listener(eventId, side));
};
